// extracted by mini-css-extract-plugin
export default {"wrapper":"w2-z"};